import { _, helpers, ts } from '_core';

import { DraftParams, Params } from './types';

export const prepareExposureData = (
  data: ts.types.widgets.TableData,
  context: ts.types.basket.BasketAnalysisContext,
  signalHandle: string,
  resources: ts.StoreState['resources'],
  basketId: number
) => {
  const newData = data.map((el) => {
    const tempRow = {} as ts.types.widgets.TableData[number];
    Object.keys(el).forEach((key) => {
      const dataKey = key.replace(`|signal|${signalHandle}`, '');
      let newKey = dataKey;
      if (dataKey == 'raw_signal') newKey = resources.baskets.find((el) => el.id == basketId)?.name;
      else newKey = resources.baskets.find((el) => el.handle == dataKey)?.name;
      if (newKey) tempRow[newKey ?? dataKey] = el[key];
    });
    return { ...tempRow, date: el.date };
  });

  return newData;
};

export const validate = (params: DraftParams) => {
  const basketCompareErrors = helpers.validations.validBasketCompare(params);
  if (!_.isEmpty(basketCompareErrors)) return basketCompareErrors;
  if (!params.factors?.[0].value) return ['Signal is a required field.'];
  return [];
};

export const getName = (
  params: Params,
  _context: ts.types.basket.BasketAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  const ts = resources.signals.find((s) => s.handle == params.factors?.[0]?.value);
  return `Signal Exposures vs. Time for ${ts.name}`;
};
